import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class PaymentTypes {
  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}payment-type`).catch((e) => {
      throw e.message;
    });
    return response.data.paymentTypes;
  };
}
export default new PaymentTypes();
